export default __webpack_public_path__ + "static/media/sf6.74cd8ba4.svg";